
    import './styles.scoped.css';
    export default {
  "empty-appear": "awsui_empty-appear_n4qlp_1xiyo_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_1xiyo_1",
  "root": "awsui_root_n4qlp_1xiyo_35",
  "empty": "awsui_empty_n4qlp_1xiyo_13",
  "row": "awsui_row_n4qlp_1xiyo_78",
  "divider": "awsui_divider_n4qlp_1xiyo_82",
  "row-control": "awsui_row-control_n4qlp_1xiyo_87",
  "field": "awsui_field_n4qlp_1xiyo_91",
  "additional-info": "awsui_additional-info_n4qlp_1xiyo_95",
  "add-row": "awsui_add-row_n4qlp_1xiyo_142",
  "add-button": "awsui_add-button_n4qlp_1xiyo_146",
  "remove-button-container": "awsui_remove-button-container_n4qlp_1xiyo_150",
  "remove-button-field-padding": "awsui_remove-button-field-padding_n4qlp_1xiyo_154",
  "remove-button-own-row": "awsui_remove-button-own-row_n4qlp_1xiyo_158",
  "remove-button": "awsui_remove-button_n4qlp_1xiyo_150"
};
  